import { render, staticRenderFns } from "./ThirdPage.vue?vue&type=template&id=fd67479c&scoped=true"
import script from "./ThirdPage.vue?vue&type=script&lang=js"
export * from "./ThirdPage.vue?vue&type=script&lang=js"
import style0 from "./ThirdPage.vue?vue&type=style&index=0&id=fd67479c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd67479c",
  null
  
)

export default component.exports